import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../Util/config";
import { InfoDTO } from "../Model/InfoDTO";
import { createAuthBaseQuery } from "../Util/baseQuery";

const url = config.API.BASE_URL + '/sysinfo';

export const sysInfoApi = createApi({
  reducerPath: 'sysInfoApi',
  baseQuery: createAuthBaseQuery(url),
  endpoints: (builder) => ({
    getSystemInfo: builder.query<InfoDTO, void>({
      query: () => ({
        url: '',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetSystemInfoQuery, useLazyGetSystemInfoQuery } = sysInfoApi;